import { render, staticRenderFns } from "./PrimerEvents.vue?vue&type=template&id=eaba1554&scoped=true&"
import script from "./PrimerEvents.vue?vue&type=script&lang=js&"
export * from "./PrimerEvents.vue?vue&type=script&lang=js&"
import style0 from "./PrimerEvents.vue?vue&type=style&index=0&id=eaba1554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaba1554",
  null
  
)

export default component.exports